module.exports = __webpack_public_path__ + "img/C1AA92_AD6E29_737889_CED1D7-256px.09e88eb2.png";